export default {
  第一作者必须填写: '第一作者必須填寫',
  自动保存: '自動保存',
  添加作者: '添加作者',
  修改作者: '修改作者',
  作者信息: '作者信息',
  第一作者: '第一作者',
  其他作者: '其他作者',
  确定: '確定',
  取消: '取消',
  存为草稿: '存為草稿',
  直接提交: '直接提交',
  '勾选收集通讯作者时，手机邮箱必须至少有一项': '勾選收集通訊作者時，手機郵箱必須至少有一項',
  '请输入{0}字符': '請輸入{0}字符',
  '请输入至少{0}字符': '請輸入至少{0}字符',
  '请输入最多{0}字符': '請輸入最多{0}字符',
  请填写完整的作者信息: '請填寫完整的作者信息',
  是否显示提交并继续: '是否顯示提交並繼續',
  是否唯一: '是否唯一'
}
